export default "__VITE_ASSET__BOaoKGTb__"